import React from 'react';
import { footerGroups, legalLinks } from '../data/footerLinks';
import { clinic } from '../data/navigation';
export function Footer() {
  return <footer id="resources" className="bg-cream" data-id="element-26" data-mp="3ggk7utmc79z0">
      <div className="mx-auto max-w-shell px-6 py-16 lg:px-10 lg:py-20" data-id="element-27" data-mp="32oe1fz8zkhcr">
        <div className="grid gap-12 lg:grid-cols-[1fr_2.2fr] lg:gap-16" data-id="element-28" data-mp="36pft9v0kpr4p">
          <div data-id="element-29" data-mp="36ppjnjpj60ax">
            <p className="text-[1.35rem] font-medium tracking-tight text-ink" data-id="element-30" data-mp="36n3c3k2n3ksp">
              Sara<span className="text-champagne" data-id="element-31" data-mp="3ucxoy1myl9cy">&rsquo;</span>s
            </p>
            <p className="mt-1 text-[0.6rem] uppercase tracking-overline text-ink-muted" data-id="element-32" data-mp="37fpks21w7ww">
              Plastic Surgery &amp; Med Spa
            </p>

            <address className="mt-8 not-italic text-[0.95rem] leading-[1.9] text-ink-soft" data-id="element-33" data-mp="3qd6qrcv3rqye">
              {clinic.addressLine1}
              <br data-id="element-34" data-mp="29y5i442prqwl" />
              {clinic.addressLine2}
            </address>

            <div className="mt-6 flex flex-col gap-2 text-[0.95rem]" data-id="element-35" data-mp="2eyt6sj3gzvnn">
              <a href={clinic.phoneHref} className="text-ink transition-colors duration-150 ease-soft hover:text-champagne-dark" data-id="element-36" data-mp="2evx98vvjb8zq">
                {clinic.phoneDisplay}
              </a>
              <a href={`mailto:${clinic.email}`} className="break-all text-ink-soft transition-colors duration-150 ease-soft hover:text-champagne-dark" data-id="element-37" data-mp="3v89f2h7oxzhx">
                {clinic.email}
              </a>
            </div>

            <p className="mt-6 text-sm text-ink-muted" data-id="element-38" data-mp="80ntqkb6ysde">{clinic.hours}</p>
          </div>

          <div className="grid gap-10 sm:grid-cols-2 lg:grid-cols-4" data-id="element-39" data-mp="31uo1e25c5ns">
            {footerGroups.map(group => <nav key={group.heading} aria-label={group.heading} data-id="element-40" data-mp="ctqouwvma9vp">
                <h2 className="text-[0.65rem] uppercase tracking-overline text-champagne-dark" data-id="element-41" data-mp="cuil89x1gbn1">
                  {group.heading}
                </h2>
                <ul className="mt-5 space-y-3" data-id="element-42" data-mp="msg7irvc7yd0">
                  {group.links.map(link => <li key={link.label} data-id="element-43" data-mp="tvmrhl25amnh">
                      <a href={link.href} className="text-[0.9rem] text-ink-soft transition-colors duration-150 ease-soft hover:text-champagne-dark" data-id="element-44" data-mp="two4vw6mvl8d">
                        {link.label}
                      </a>
                    </li>)}
                </ul>
              </nav>)}
          </div>
        </div>

        <div className="mt-14 flex flex-col gap-5 border-t border-line pt-8 lg:flex-row lg:items-center lg:justify-between" data-id="element-45" data-mp="1clcmo99tlafx">
          <p className="text-xs text-ink-muted" data-id="element-46" data-mp="1mjsc87t78bnb">
            © {new Date().getFullYear()} Sara&rsquo;s Plastic Surgery &amp; Med Spa. All
            rights reserved.
          </p>
          <ul className="flex flex-wrap items-center gap-x-6 gap-y-2" data-id="element-47" data-mp="1rgsh4febb8cu">
            {legalLinks.map(link => <li key={link.label} data-id="element-48" data-mp="3ta8a3ixvgzaz">
                <a href={link.href} className="whitespace-nowrap text-xs text-ink-muted transition-colors duration-150 ease-soft hover:text-champagne-dark" data-id="element-49" data-mp="3t9gggdnu5bnc">
                  {link.label}
                </a>
              </li>)}
          </ul>
        </div>

        <p className="mt-8 max-w-3xl text-xs leading-relaxed text-ink-muted" data-id="element-50" data-mp="21nblfodaqaj9">
          Individual results vary. Information on this site is for educational purposes and
          is not a substitute for a medical consultation.
        </p>
      </div>
    </footer>;
}